import apiClient from '../apiClient';
import { GET_AREA_BY_ID_URL } from '../apiUrl';

const getAreaByIdApi = Id => {
  return apiClient.get(GET_AREA_BY_ID_URL(Id));
};

export default getAreaByIdApi;
